import { REQUEST_DELIVERY, REQUEST_DELIVERY_FAILURE, REQUEST_DELIVERY_SUCCESS } from "../../constant/DashboardConstant";

const initialState = {
  delivery: {
    data: [],
  },
};

export const deliveryReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_DELIVERY:
      return {
        ...state,
        delivery: {
          data: [],
          status: 'fetching',
          isLoading: true,
        },
      };
    case REQUEST_DELIVERY_SUCCESS:
      return {
        ...state,
        delivery: {
          data: payload,
          status: 'ready',
          isLoading: false,
        },
      };
    case REQUEST_DELIVERY_FAILURE:
      return {
        ...state,
        delivery: {
          data: [],
          status: 'failure',
          isLoading: false,
        },
      };
    default:
      return state;
  }
}